/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Permission_TitleInputs */

const en_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to manage your team.`)
};

const fr_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n’avez pas l’autorisation de gérer votre équipe.`)
};

const de_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben keine Berechtigung, Ihr Team zu verwalten.`)
};

const it_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai l'autorizzazione per gestire il tuo team.`)
};

const ru_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас нет разрешения на управление своей командой.`)
};

const es_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes permiso para administrar tu equipo.`)
};

const zh_cn2_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您没有管理团队的权限。`)
};

const ja_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを管理する権限がありません。`)
};

const hi_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको अपनी टीम का प्रबंधन करने की अनुमति नहीं है।`)
};

const pt_pt2_team_manager_no_permission_title = /** @type {(inputs: Team_Manager_No_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem permissão para gerenciar sua equipe.`)
};

/**
* | output |
* | --- |
* | "You do not have permission to manage your team." |
*
* @param {Team_Manager_No_Permission_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_permission_title = /** @type {((inputs?: Team_Manager_No_Permission_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Permission_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_no_permission_title(inputs)
	if (locale === "de") return de_team_manager_no_permission_title(inputs)
	if (locale === "it") return it_team_manager_no_permission_title(inputs)
	if (locale === "ru") return ru_team_manager_no_permission_title(inputs)
	if (locale === "es") return es_team_manager_no_permission_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_no_permission_title(inputs)
	if (locale === "ja") return ja_team_manager_no_permission_title(inputs)
	if (locale === "hi") return hi_team_manager_no_permission_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_no_permission_title(inputs)
	return en_team_manager_no_permission_title(inputs)
});